import React from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Stack,
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import {
  formatDateTime,
  tableHeadCellSx,
  tableBodyCellSx,
} from "bundles/Internal/components/CompanyShowPage";

function CompanyRecruitersTab({ recruiters, loading }) {
  const navigate = useNavigate();

  if (loading) {
    return (
      <Stack spacing={1} sx={{ p: 4 }}>
        {[...Array(5)].map((_, i) => (
          <Skeleton key={i} variant="rectangular" height={36} />
        ))}
      </Stack>
    );
  }
  if (!recruiters || recruiters.length === 0) {
    return (
      <Box sx={{ p: 8, textAlign: "center" }}>
        <Typography sx={{ color: "hsl(150 10% 46%)", fontSize: 14 }}>
          No recruiters for this company.
        </Typography>
      </Box>
    );
  }
  return (
    <Box sx={{ overflowX: "auto" }}>
      <Table size="small">
        <TableHead>
          <TableRow>
            {["Id", "Name", "Email", "Phone", "Job title", "Godview", "Active", "Sign-ins", "Created"].map((label) => (
              <TableCell key={label} sx={tableHeadCellSx}>{label}</TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {recruiters.map((r) => {
            const name = r.full_name || [r.first_name, r.last_name].filter(Boolean).join(" ") || `#${r.id}`;
            return (
              <TableRow
                key={r.id}
                hover
                onClick={() => navigate(`/internal/recruiters/${r.id}`)}
                sx={{
                  "&:hover": { backgroundColor: "hsl(140 8% 90%)", cursor: "pointer" },
                  "&:last-child td": { borderBottom: "none" },
                }}
              >
                <TableCell sx={tableBodyCellSx}>#{r.id}</TableCell>
                <TableCell sx={tableBodyCellSx}>{name}</TableCell>
                <TableCell sx={tableBodyCellSx}>{r.email || "—"}</TableCell>
                <TableCell sx={tableBodyCellSx}>{r.phone || "—"}</TableCell>
                <TableCell sx={tableBodyCellSx}>{r.job_title || "—"}</TableCell>
                <TableCell sx={tableBodyCellSx}>
                  {r.godview_url ? (
                    <a
                      href={r.godview_url}
                      target="_blank"
                      rel="noopener noreferrer"
                      onClick={(e) => e.stopPropagation()}
                      style={{ color: "#079344", fontWeight: 600, textDecoration: "none" }}
                      onMouseOver={(e) => { e.currentTarget.style.textDecoration = "underline"; }}
                      onMouseOut={(e) => { e.currentTarget.style.textDecoration = "none"; }}
                    >
                      Godview ↗
                    </a>
                  ) : "—"}
                </TableCell>
                <TableCell sx={tableBodyCellSx}>{r.active ? "Yes" : "No"}</TableCell>
                <TableCell sx={tableBodyCellSx}>{r.sign_in_count ?? 0}</TableCell>
                <TableCell sx={tableBodyCellSx}>{formatDateTime(r.created_at) || "—"}</TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </Box>
  );
}

export default CompanyRecruitersTab;
